module.exports = __webpack_public_path__ + "img/Screenshot-1.abcaab81.png";